import type React from 'react';
import { RouterProvider } from 'react-aria-components';
import { type NavigateOptions, useHref, useNavigate } from 'react-router-dom';

declare module 'react-aria-components' {
  interface RouterConfig {
    routerOptions: NavigateOptions;
  }
}

/**
 * Routes every react-aria `href` (TailGrids links, menu items, breadcrumbs) through react-router, so
 * they navigate client-side instead of reloading the page. Mounted once inside <BrowserRouter>.
 */
export function AriaRouterProvider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  return (
    <RouterProvider navigate={navigate} useHref={useHref}>
      {children}
    </RouterProvider>
  );
}
